var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { EsigningProviderAuthenticationModeSlug, EsigningRecipientType } from 'shared/domains/apollo/generated/types';
export const getInitialValues = (recipient) => {
    if (!recipient) {
        return {
            email: '',
            type: EsigningRecipientType.Signatory,
            authenticationMode: EsigningProviderAuthenticationModeSlug.Email,
        };
    }
    const { type, name, email, authenticationMode, firstName, lastName, label, message, mobile, title } = recipient;
    return {
        type,
        name,
        email,
        authenticationMode,
        firstName,
        lastName,
        label,
        message,
        mobile,
        title,
    };
};
/**
 * Modifies the input before sending it to the API
 *
 * We remove the `mobile` property if the `authenticationMode` is not `SmsOtp`
 *
 * We remove the `type` if the esigning is pending because we are not allowed do modify it while pending
 */
export const modifyInput = (input, isEsigningPending) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { authenticationMode, type, mobile } = input, rest = __rest(input, ["authenticationMode", "type", "mobile"]);
    return Object.assign(Object.assign({}, rest), { authenticationMode, type: isEsigningPending ? undefined : type, mobile: authenticationMode === EsigningProviderAuthenticationModeSlug.SmsOtp ? mobile : undefined });
};
